import React from 'react'
import Zoom from 'react-reveal/Zoom';
function About_discraption() {
  return (
    <div className=''>
      {/* -------------------------------Mobile view--------------------------------- */}
      <Zoom>
      <div className='container d-sm-block d-md-none'>
        <div className='text-center mt-3 mobile_About_Discraption_text'>
          <h1 className='display-4 text-center'>Who We Are</h1>
          <p className='' >InternsElite is an organisation with the mission of preparing students for professional success in both technical and nontechnical fields through meaningful internship experiences. Here at InternsElite, we guide students in the right direction by giving them the knowledge, tools, and resources they need to make an informed decision about their future careers. Using artificial intelligence (AI) software and other cutting-edge technology, we teach our pupils and help them improve their skills in general.</p>
          <h2 className='display-6 border-bottom pb-4 pt-2'>At InternsElite, live the real world and rule the world. </h2>
        </div>
      </div>
      </Zoom>


      {/* -------------------------------Dasktop view--------------------------------- */}
      <Zoom>
      <div className='container d-none d-md-block pt-4'>
        <div className='row'>
            <div className='container px-5'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-4'>Who We Are</h1>
                <p>InternsElite is an organisation with the mission of preparing students for professional success in both technical and nontechnical fields through meaningful internship experiences. Here at InternsElite, we guide students in the right direction by giving them the knowledge, tools, and resources they need to make an informed decision about their future careers. Using artificial intelligence (AI) software and other cutting-edge technology, we teach our pupils and help them improve their skills in general.</p>
                <h2 className='display-6'>At InternsElite, live the real world and rule the world.</h2>
            </div>
            </div>
        </div>
      </div>
      </Zoom>
    </div>
  )
}

export default About_discraption
